import React from 'react';
import styles from '../NotFound/styles.module.scss';
import routeStyles from './styles.module.scss';
import DashboardLayout from '../../layouts/DashboardLayout';
import { Breadcrumb } from 'antd';

const RouteErrorScreen = () => {

    const handleAction = () => {
        window.location.reload(true);
    }

    return (
        <DashboardLayout>
            <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item>Home</Breadcrumb.Item>
                <Breadcrumb.Item>Not Found</Breadcrumb.Item>
            </Breadcrumb>
            <div className={styles.container}>
                <div className={styles.headline}>
                    Oops! Hệ thống vừa xảy ra sự cố
                </div>
                <div className={styles.errorContent}>
                    Chúng tôi rất tiếc vì điều này, bạn hãy click vào nút dưới đây để tiếp tục
                    <div className={routeStyles.buttonWrapper}>
                        <button className={`mainButton ${routeStyles.continueButton}`}
                                onClick={handleAction}>
                            Tiếp tục
                        </button>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    )
}

export default RouteErrorScreen
